import Vue from 'vue';
import md5 from 'js-md5';
import config from '@/config/index';
export default {
    // 密钥修改
    editValidatePass(data) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/operationPassword/edit`,
            method: 'post',
            data,
        })
    },
    // 协议相关
    // 版本状态
    editVersionStatus(data, operatingPassword, needCheckOperating) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/protocolVersion/updateStatus`,
            method: 'post',
            data,
            headers: {
                operatingPassword: md5(operatingPassword),
                needCheckOperating: needCheckOperating || false
            }
        })
    },
    // 协议状态
    editDealStatus(data, operatingPassword, needCheckOperating) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/protocol/updateStatus`,
            method: 'post',
            data,
            headers: {
                operatingPassword: md5(operatingPassword),
                needCheckOperating: needCheckOperating || false
            }
        })
    },
    // 服务器状态
    editServerStatus(data, operatingPassword, needCheckOperating) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/protocolVersionServerRelevance/updateStatus`,
            method: 'post',
            data,
            headers: {
                operatingPassword: md5(operatingPassword),
                needCheckOperating: needCheckOperating || false
            }
        })
    },
    // 总端口状态
    editSortsStatus(data, operatingPassword, needCheckOperating) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/protocolVersionServerRelevance/updateTotalPortIssued`,
            method: 'post',
            data,
            headers: {
                operatingPassword: md5(operatingPassword),
                needCheckOperating: needCheckOperating || false
            }
        })
    },
    // 端口状态
    editSortStatus(data, operatingPassword, needCheckOperating) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/protocolVersionServerPort/updatePortIssued`,
            method: 'post',
            data,
            headers: {
                operatingPassword: md5(operatingPassword),
                needCheckOperating: needCheckOperating || false
            }
        })
    },
    // 设备类型相关
    // 状态
    editDeviceTypeStatus(data, operatingPassword, needCheckOperating) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/deviceCategory/changeStatus`,
            method: 'post',
            data,
            headers: {
                operatingPassword: md5(operatingPassword),
                needCheckOperating: needCheckOperating || false
            }
        })
    },
    // 修改
    editDeviceType(data, operatingPassword, needCheckOperating) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/deviceCategory/edit`,
            method: 'post',
            data,
            headers: {
                operatingPassword: md5(operatingPassword),
                needCheckOperating: needCheckOperating || false
            }
        })
    },
    // 设备品牌相关
    // 状态
    editDeviceBrandStatus(data, operatingPassword, needCheckOperating) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/brand/changeStatus`,
            method: 'post',
            data,
            headers: {
                operatingPassword: md5(operatingPassword),
                needCheckOperating: needCheckOperating || false
            }
        })
    },
    // 修改
    editDeviceBrand(data, operatingPassword, needCheckOperating) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/brand/edit`,
            method: 'post',
            data,
            headers: {
                operatingPassword: md5(operatingPassword),
                needCheckOperating: needCheckOperating || false
            }
        })
    },
    // 设备系列相关
    // 状态
    editDeviceSeriesStatus(data, operatingPassword, needCheckOperating) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/series/changeStatus`,
            method: 'post',
            data,
            headers: {
                operatingPassword: md5(operatingPassword),
                needCheckOperating: needCheckOperating || false
            }
        })
    },
    // 修改
    editDeviceSeries(data, operatingPassword, needCheckOperating) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/series/edit`,
            method: 'post',
            data,
            headers: {
                operatingPassword: md5(operatingPassword),
                needCheckOperating: needCheckOperating || false
            }
        })
    },
    // 功能参数相关
    // 状态
    editDeviceParameterStatus(data, operatingPassword, needCheckOperating) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/function/changeStatus`,
            method: 'post',
            data,
            headers: {
                operatingPassword: md5(operatingPassword),
                needCheckOperating: needCheckOperating || false
            }
        })
    },
    // 修改
    editDeviceParameter(data, operatingPassword, needCheckOperating) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/function/edit`,
            method: 'post',
            data,
            headers: {
                operatingPassword: md5(operatingPassword),
                needCheckOperating: needCheckOperating || false
            }
        })
    },
}